import type { Submission } from '@/hooks/submissions/useSubmission';

const STUDY_SITE_DETAIL_CATEGORIES = [
  'Modification',
  'Correction Request',
] as const;

export function shouldShowSubmissionDetailPanel(
  submission: Submission
): boolean {
  // A standalone filing (GEN/Advisory/NHSR/Invoice owned by a synthetic
  // wrapper study, or an ownerless legacy row) has no real Study/StudySite to
  // show. Its submission_type still reads 'Study', so gate on `standalone`
  // first — otherwise the "Study Details" panel renders empty for a GEN.
  if (submission.standalone) {
    return false;
  }

  if (
    submission.submission_type === 'Study' ||
    submission.submission_type === 'StudySite'
  ) {
    return true;
  }

  const category = submission.submission_template?.category;
  const ownerType = submission.owner?.type;
  return (
    !!category &&
    (STUDY_SITE_DETAIL_CATEGORIES as readonly string[]).includes(category) &&
    (ownerType === 'Study' || ownerType === 'StudySite')
  );
}
